import { useDispatch, useSelector } from 'react-redux';

import {
  handleOpenSetting,
  handleSelector,
  handleToggleSSR,
} from '../store/slices/essSwitchSlice';

import {
  tesHandleOpenSetting,
  tesHandleSelector,
  tesHandleToggleSSR,
} from '../store/slices/tesSwitchSlice';

import { useMediaQuery } from 'react-responsive';
import styled, { css } from 'styled-components';

import SSRInfoContainer from './SSRInfoContainer';
import SSRToggleSWitch from './SSRToggleSwitch';
import SSRSelect from './SSRSelect';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexEnd,
  justifyContentSpaceBetween,
  layerA,
} from '../styles/commonStyles';
import SSRInfoCommonContainer from './SSRInfoCommonCopntainer';
import { useState } from 'react';
import { useEffect } from 'react';
import { selectUnits } from '../store/slices/settings/unitsSlice';
import { selectUserInfo, selectUserPermissions } from '../store/slices/userSlice';
import AdminSSRItemDetails from './AdminSSRItemDetails';
import ContainerLogin from '../adminPassword/ContainerLogin';
import {
  updateBlowerSettingService,
  updateSwitchSettingService,
} from '../../services';
import SwitchNameSelector from './SwitchNameSelector';
import { useReportCommandFailure } from '../../hooks/useDeviceCommand';
import { useSwitchState } from '../../hooks/useSwitchState';

const SSRDetail = ({
  swtName,
  data,
  id,
  location,
  machine,
  indivLocationName,
  isUpdating,
  setIsUpdating,
  localActivatedHeaters,
  setLocalActivatedHeaters
}) => {
  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;
  const permissions = useSelector(selectUserPermissions);
  const disable = !permissions.WRITE;
  
  const { flat: switchData } = useSwitchState(swtName);
  const switchStatus = switchData[location][machine];

  const { deviceMac, heaterThermocoupleMap, activeThermocouples } = switchStatus;

  const heaters = (data?.specs || []).map((spec) => ({
    current: spec?.current ?? 0,
    currentCurrent: spec?.currentCurrent ?? 0,
    elementName: spec?.elementName ?? '',
    partNumber: spec?.partNumber ?? '',
    voltage: spec?.voltage ?? 0,
    wattage: spec?.wattage ?? 0,
    lengths: spec?.lengths ?? 0,
  }));
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const { isSettingOpen, buttonStatus } = data;
  const dispatch = useDispatch();
  const reportFailure = useReportCommandFailure(
    swtName,
    deviceMac,
    switchStatus.device_name,
  );
  const { isAdministrator } = useSelector(selectUserInfo);
  const [openPasswordBox, setOpenPasswordBox] = useState(false);

  const setSettingOpen = (status) =>
    dispatch(
      (swtName === 'ess' ? handleOpenSetting : tesHandleOpenSetting)({
        location,
        machine,
        id: `ssr${id}`,
        status,
      })
    );

  const handleMobileSettingButton = () => {
    if (isSettingOpen) {
      setSettingOpen(false);
    } else if (isAdministrator) {
      setSettingOpen(true);
    } else {
      setOpenPasswordBox(true);
    }
  };

  const [isOverAmp, setIsOverAmp] = useState(false);
  const [SSRSwitchName, setSSRSwitchName] = useState('');

  const disabled = buttonStatus === 'flt' || buttonStatus === 'off';

  useEffect(() => {
    const maxTemp = data?.specs[0]?.current * 0.2 + data?.specs[0]?.current;
    const minTemp = -data?.specs[0]?.current * 0.2 + data?.specs[0]?.current;

    const check =
      data?.specs[0]?.currentCurrent > maxTemp ||
      data?.specs[0]?.currentCurrent < minTemp;

    check ? setIsOverAmp(true) : setIsOverAmp(false);
  }, [data?.specs[0]]);

useEffect(() => {

}, [localActivatedHeaters]);
  const integratedButtonHandler = (data) => {
    switch (data.button) {
      case 'SSRSelect':
        const newHeaterThermocoupleMap = {
          heater_thermocouple_map: heaterThermocoupleMap.map(
            (select, index) => {
              if (index === id - 1) {
                return Number(data.data.slice(-2));
              } else {
                return select;
              }
            }
          ),
        };
        swtName === 'ess'
          ? updateSwitchSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              dispatch(
                handleSelector({
                  location,
                  machine,
                  id: data.id,
                  data: data.data,
                })
              );
            })
          : updateBlowerSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              dispatch(
                tesHandleSelector({
                  location,
                  machine,
                  id: data.id,
                  data: data.data,
                })
              );
            });
        break;
      case 'toggle': {
        if (isUpdating) return;
        if (!Array.isArray(localActivatedHeaters)) {
          reportFailure(new Error('the heater list has not loaded yet'));
          return;
        }
        setIsUpdating(true);
        const newActivatedHeaters = {
          activated_heaters: localActivatedHeaters.map((value, index) =>
            index === id - 1 ? Number(data.buttonStatus === 'on' ? 1 : 0) : value,
          ),
        };
        const [updateSetting, toggleSSR] =
          swtName === 'ess'
            ? [updateSwitchSettingService, handleToggleSSR]
            : [updateBlowerSettingService, tesHandleToggleSSR];

        updateSetting([deviceMac], newActivatedHeaters)
          .then((serverData) => {
            const applied = serverData?.[0]?.activated_heaters;
            if (
              !Array.isArray(applied) ||
              applied.length !== newActivatedHeaters.activated_heaters.length
            ) {
              return;
            }
            setLocalActivatedHeaters(applied);
            const matches = applied.every(
              (value, idx) => value === newActivatedHeaters.activated_heaters[idx],
            );
            if (matches) {
              dispatch(
                toggleSSR({
                  location,
                  machine,
                  id: data.id,
                  buttonStatus: data.buttonStatus,
                }),
              );
            }
          })
          .catch(reportFailure)
          .finally(() => setIsUpdating(false));
        break;
      }
      default:
        break;
    }
  };

  return (
    <>
      {isMobile ? (
        <Wrapper
          isMobile={isMobile}
          isOverAmp={isOverAmp}
          isOff={buttonStatus === 'off'}
          isFault={buttonStatus === 'flt'}
        >
          <MobileHeaderRow>
            <ToggleSWitchContainer isMobile={true}>
              <SSRToggleSWitch
                isMobile={true}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRSelect
              isMobile={true}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />
            <MobileSettingButton
              type='button'
              disabled={disable}
              aria-label={
                isSettingOpen
                  ? `close ssr ${id} heater settings`
                  : `open ssr ${id} heater settings`
              }
              onClick={() => !disable && handleMobileSettingButton()}
            >
              <MobileSettingIcon src='/images/admin-setting.svg' />
            </MobileSettingButton>
          </MobileHeaderRow>

          {isSettingOpen ? (
            <AdminSSRItemDetails
              isMobile={true}
              id={id}
              data={data}
              isEnable={buttonStatus === 'on'}
              isFault={buttonStatus === 'flt'}
              isWarn={data.warn === 1}
              handleButtonClick={() => setSettingOpen(false)}
              location={location}
              machine={machine}
              swtName={swtName}
            />
          ) : (
            heaters.map((heater, index) => (
              <HeaterBlock key={index}>
                {heaters.length > 1 && (
                  <HeaterBlockTitle>
                    heater {index + 1} of {heaters.length}
                  </HeaterBlockTitle>
                )}

                <HeaterFigures>
                  <SSRInfoCommonContainer
                    data={{ t: heater.current, a: heater.currentCurrent }}
                    title='current'
                    unit='a'
                    disabled={disable}
                  />
                  <SSRInfoCommonContainer
                    data={heater.wattage}
                    title='wattage'
                    unit='w'
                    disabled={disabled}
                  />
                  <SSRInfoCommonContainer
                    data={heater.voltage}
                    title='voltage'
                    unit='v'
                    disabled={disabled}
                  />
                  <SSRInfoCommonContainer
                    data={heater.lengths}
                    title='length'
                    unit={'ft'}
                    disabled={disabled}
                  />
                </HeaterFigures>

                <SectionContainer isLast={true}>
                  <SSRInfoCommonContainer
                    disabled={disabled}
                    data={{
                      a: `${heater.elementName} - ${heater.partNumber}`,
                      b: `${heater.current} a / ${heater.wattage} w / ${heater.voltage} v / ${heater.lengths} ft`,
                    }}
                    title='description'
                    unit={null}
                  />
                </SectionContainer>
              </HeaterBlock>
            ))
          )}

          {openPasswordBox && (
            <MobilePasswordWrapper onClick={() => setOpenPasswordBox(false)}>
              <ContainerLogin
                setIsSettingOpen={() => setSettingOpen(true)}
                handleClose={() => setOpenPasswordBox(false)}
                isReadyToClose={true}
              />
            </MobilePasswordWrapper>
          )}
        </Wrapper>
      ) : (
        <Wrapper>
          <FlexContainer>
            <SSRSelect
              isMobile={false}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />

            <ToggleSWitchContainer>
              <SSRToggleSWitch
                isMobile={false}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRInfoContainer
              swtName={swtName}
              data={data}
              id={id}
              location={location}
              machine={machine}
              isSettingOpen={isSettingOpen}
              isOverAmp={isOverAmp}
              SSRSwitchName={SSRSwitchName}
              setSSRSwitchName={setSSRSwitchName}
            />
          </FlexContainer>
          <SwitchNameSelectorWrapper>
            {isSettingOpen && (
              <>
                <SwitchNameSelector
                  data={data}
                  SSRSwitchName={SSRSwitchName}
                  setSSRSwitchName={setSSRSwitchName}
                  ssrId={id - 1}
                  swtName={swtName}
                  location={location}
                  machine={machine}
                />
              </>
            )}
          </SwitchNameSelectorWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default SSRDetail;
const SectionContainer = styled.section`
  width: 100%;
  ${justifyContentSpaceBetween}

  ${(p) =>
    p.isFirst &&
    css`
      ${justifyContentFlexEnd};
    `};

  ${(p) =>
    p.isLast &&
    css`
      ${flexBoxCenter};
    `}
`;

const MobileHeaderRow = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween};
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 6px;
`;

const HeaterBlock = styled.div`
  width: 100%;
  ${flexDirectionColumn};
  align-items: stretch;

  & + & {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 0.5px solid #ffffff29;
  }
`;

const HeaterBlockTitle = styled.span`
  font-size: 8px;
  color: #95ff45;
  text-align: left;
  margin-bottom: 2px;
`;

const HeaterFigures = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-around;
  gap: 4px 8px;

  > div:first-child {
    margin-left: 0;
  }
`;

const MobileSettingButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;

  ${layerA};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

const MobileSettingIcon = styled.img`
  height: 60%;
`;

const MobilePasswordWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  ${flexBoxCenter};
  z-index: 100;
  cursor: pointer;
`;

const Wrapper = styled.div`
  ${(p) =>
    p.isMobile
      ? css`
          width: 289px;
          min-height: 151px;
          border-radius: 16px;
          margin-bottom: 8px;
          ${flexDirectionColumn};
          align-items: stretch;
          padding: 8px 6px;
          position: relative;

          background: transparent
            linear-gradient(
              180deg,
              ${p.isOff ? '#565656' : '#233a54'} 0%,
              ${p.isOff ? '#1d1d1d' : '#060d19'} 100%
            );
          box-shadow: inset 0px 0.5px 1px #ffffff29, 0px 0px 1px #000000;
          border: 0.5px solid #000000;

          ${p.isFault &&
          css`
            border: 1px solid red;
          `}

          ${p.isOverAmp &&
          css`
            border: 1px solid #ff7800;
          `}
        `
      : css`
          width: 100%;

          display: flex;
          flex-direction: column;
          padding: 0 5px;

          margin-bottom: 5px;

          transition: all 200ms ease-in-out;

          position: relative;
        `}
`;

const FlexContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;

`;

const ToggleSWitchContainer = styled.div`
  ${(p) =>
    p.isMobile &&
    css`
      flex-shrink: 0;
    `}
`;

const SwitchNameSelectorWrapper = styled.div`
  position: absolute;
  top: 62px;
  width: 183px;
  height: auto;
  ${alignItemsFlexStart};
  flex-direction: column;
  gap: 6px;
`;
